/** Explicit local verification only: no analytics, storage, identifiers, or
 * coordinates. Enable with ?debugWhatsOn=1 and inspect the browser console.
 * Counts describe returned candidates before/after defensive circle filtering
 * and final composition; server SQL eligibility has already run before fetch.
 */
export function summarizeWhatsOn({ surface, centerKind, counts, followCandidates, compositionCounts, items }) {
  const cohorts = new Map();
  for (const item of items) {
    const meta = item._recommendation || {};
    const cohort = { origin: meta.origin || 'unknown', centerKind,
      distanceBand: meta.distanceBand || 'unknown', provider: meta.provider || item.source_type || 'unknown' };
    const key = JSON.stringify(cohort);
    const previous = cohorts.get(key);
    cohorts.set(key, { ...cohort, count: (previous?.count || 0) + 1 });
  }
  return { surface, centerKind, candidates: {
    primaryFetched: counts?.primaryFetched || 0, primaryEligible: counts?.primaryEligible || 0,
    fartherFetched: counts?.fartherFetched || 0, fartherEligible: counts?.fartherEligible || 0,
    followCandidates, rendered: items.length
  }, composition: compositionCounts || null, cohorts: [...cohorts.values()] };
}

export function recordWhatsOnDiagnostics(input) {
  if (typeof window === 'undefined' || new URLSearchParams(window.location.search).get('debugWhatsOn') !== '1') return;
  console.debug('[whats-on verification]', summarizeWhatsOn(input));
}
